import {
  EnvironmentProviders,
  Provider
} from '@angular/core';
import {
  ENVIRONMENT_INITIALIZER,
  inject
} from '@angular/core';
import { IconsService } from './icons.service';

export function provideIcons(): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(IconsService),
      multi: true
    }
  ];
}
